import styled from 'styled-components';

export const Container = styled.img`
  width: 250px;

  @media screen and (min-width: 766px) {
    width: 250px;
  }
`;
